export default __webpack_public_path__ + "static/media/004-boy-1.660aa3c0.svg";